<template>
    <section class="app-main">
        <div class="title">
            <p @click="$router.go(-1)"><i class="el-icon-back"></i>返回商品列表</p>
            <p>用户列表</p>
        </div>
        <div class="top-bar">
            <el-input placeholder="输入手机号或邮箱" v-model="keywords"  style="width:300px;" @change="getData" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-date-picker 
                v-model="date"
                @change="getData" 
                type="datetimerange" 
                range-separator="至" 
                start-placeholder="开始日期" 
                end-placeholder="结束日期" 
                style="width:400px;margin-left:20px">
            </el-date-picker>
        </div>
        <!-- 商品列表 -->
        <div class="content">
            <el-table :data="tableData"  height="550" style="width: 100%">
                <el-table-column  prop="" label="头像" align="center" width="120">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.user.pic_url" :src="scope.row.user.pic_url" />
                    </template>
                </el-table-column>
                <el-table-column  prop="user.nickname" label="用户" align="center"></el-table-column>
                <el-table-column  prop="user.phone" label="手机号" align="center"></el-table-column>
                <el-table-column  prop="user.email" label="邮箱" align="center"></el-table-column>
                <el-table-column  prop="" label="商品图片" align="center" width="120">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.bargain_goods.goods.image" :src="scope.row.bargain_goods.goods.image.remote_url" />
                    </template>
                </el-table-column>
                <el-table-column  prop="bargain_goods.goods_info.name" label="商品名称" align="center" width="250" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="bargain_goods_sku.goods_sku.attr_symbol_string" label="商品规格" align="center"></el-table-column>
                <el-table-column  prop="bargain_goods_sku.goods_sku.price" label="原价(C$)" align="center" width="100"></el-table-column>
                <el-table-column  prop="" label="最终价格(C$)" align="center" width="110">
                    <template slot-scope="scope">
                        <span>{{(scope.row.bargain_goods_sku.goods_sku.price - scope.row.user_bargain_log_sum).toFixed(2)}}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="bargain_goods_sku.goods_sku.attr_symbol_string" label="订单号" align="center" width="160">
                    <template slot-scope="scope">
                        <span>{{scope.row.order ? scope.row.order.title : '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="created_at" label="参与时间" align="center" width="160"></el-table-column>
            </el-table>
            <el-pagination background @current-change="loadPage" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </div>
    </section>
</template>

<script>
import MImg   from '../../../../components/Image'
import {  bargain_user } from '@/api/market.js'
export default {
    components: {MImg},
    data() {
        return {
            date: [], // 时间
            keywords:'',
            page:1,
            total:0,
            size: 0,
            tableData:[],
        }
    },
    methods: {
        search() {
            this.page = 1;
            this.getData()
        },
        getData() {
            let params = {
                page: this.page,
                limit: 20
            }
            if(this.keywords != '') {
                params.keywords = this.keywords
            }
            if(this.date && this.date.length != 0){
                params.start_time = this.date[0];
                params.end_time = this.date[1];
            }
            bargain_user(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                    this.total = 0
                    this.size  = 0
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    }
}
</script>

<style lang="less" scoped>
.title {
    margin-left: 10px;
    p:nth-child(1) {
        text-decoration: underline;
        color: #169bff;
        margin-bottom: 10px;
        cursor: pointer;
    }
    p:nth-child(2) {
        margin-bottom: 10px;
        font-size: 26px;
        font-weight: bold;
        color: #0A1629;
    }
}
</style>


